import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { TabsContent } from "@/components/ui/tabs";
import { EmptyState, StatusBadge, inr } from "@/components/bits";
import api, { errMsg } from "@/lib/api";

export function ReimbursementsTab({ claims, onRefresh }) {
  const reviewClaim = async (id, action) => {
    try {
      await api.post(`/employer/reimbursements/${id}/review`, { action });
      toast.success(`Claim ${action === "paid" ? "marked paid" : action + "d"}`);
      onRefresh();
    } catch (e) {
      toast.error(errMsg(e));
    }
  };

  return (
    <TabsContent value="reimbursements">
      {claims.length === 0 ? (
        <EmptyState title="No reimbursement claims" description="Employee expense claims will appear here for approval." testId="claims-empty" />
      ) : (
        <div className="space-y-3" data-testid="claims-list">
          {claims.map((c) => (
            <div key={c.id} className="bg-white border border-border/60 rounded-xl p-5 flex flex-wrap items-center justify-between gap-4" data-testid={`claim-${c.id}`}>
              <div>
                <p className="font-semibold text-sm text-[#0B1B3D]">{c.name} — <span className="capitalize">{c.category.replace(/_/g, " ")}</span></p>
                <p className="text-xs text-muted-foreground mt-1">{c.date} · {c.description || "No description"}</p>
              </div>
              <div className="flex items-center gap-3">
                <span className="font-heading font-bold">{inr(c.amount)}</span>
                <StatusBadge status={c.status} />
                {c.status === "pending" && (
                  <>
                    <Button size="sm" className="rounded-full bg-emerald-600 hover:bg-emerald-700" onClick={() => reviewClaim(c.id, "approve")} data-testid={`claim-approve-${c.id}`}>Approve</Button>
                    <Button size="sm" variant="outline" className="rounded-full text-red-600 border-red-200" onClick={() => reviewClaim(c.id, "reject")} data-testid={`claim-reject-${c.id}`}>Reject</Button>
                  </>
                )}
                {c.status === "approved" && (
                  <Button size="sm" className="rounded-full bg-[#2563EB]" onClick={() => reviewClaim(c.id, "paid")} data-testid={`claim-paid-${c.id}`}>Mark Paid</Button>
                )}
              </div>
            </div>
          ))}
        </div>
      )}
    </TabsContent>
  );
}
